import { Controller } from "@hotwired/stimulus"

// Collapsible per-tenant section on the group resource-sharing calendar. Persists the
// collapsed/expanded state per tenant in localStorage (mirrors planning-section).
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { sectionId: String }

  static STORAGE_KEY = "resource_share_section_states"

  connect() {
    this.expanded = this.loadState()
    this.applyState()
  }

  loadState() {
    try {
      const saved = localStorage.getItem(this.constructor.STORAGE_KEY)
      const states = saved ? JSON.parse(saved) : {}
      return states[this.sectionIdValue] !== false
    } catch (_e) {
      return true
    }
  }

  saveState() {
    try {
      const saved = localStorage.getItem(this.constructor.STORAGE_KEY)
      const states = saved ? JSON.parse(saved) : {}
      states[this.sectionIdValue] = this.expanded
      localStorage.setItem(this.constructor.STORAGE_KEY, JSON.stringify(states))
    } catch (_e) {
      // Ignore storage errors
    }
  }

  applyState() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.expanded)
    }
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.expanded ? "rotate(0deg)" : "rotate(-90deg)"
    }
  }

  toggle() {
    this.expanded = !this.expanded
    this.applyState()
    this.saveState()
  }
}
